import { CONTAINER_PADDING_ON_SIDES } from './constants';

export const isTileHiddenToTheLeft = (container: HTMLElement, tileElement: HTMLElement): boolean => {
    const containerLeft = container.getBoundingClientRect().left;
    const tileLeft = tileElement.getBoundingClientRect().left;
    return tileLeft < containerLeft + CONTAINER_PADDING_ON_SIDES;
};
